import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityGoal } from "../../entity/EntityGoal";

export class DtoGoalsPostReq extends EntityGoal {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
